import * as React from "react";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import { Button } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { slots, tableStyles } from "./Table/utils";
import useAdminData from "../Queries/adminDataQuery";
import { useBoundStore } from "useStore";

function EnhancedTableToolbar({ numSelected, handleBulkUpdate }) {
  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },

        backgroundColor: "#2196F31F",
        borderBottom: "1px solid #E0E0E0",
        height: "64px",
        boxShadow: "0px 2px 4px rgba(0,0,0,0.05)",
        ...(numSelected > 0 && {
          backgroundColor: "#2196F31F",
          border: "1px solid #2196F3",
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{
            flex: "1 1 100%",
            color: "#00000099",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "16px",
            letterSpacing: "0.15px",
          }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          {numSelected} tickets seleccionados
        </Typography>
      ) : (
        <Typography
          sx={{
            flex: "1 1 100%",
            color: "#00000099",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "16px",
            letterSpacing: "0.15px",
          }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Seleccione para Finalizar
        </Typography>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Finalizar">
          <Button
            sx={{
              backgroundColor: "#002878",
              color: "#fff",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "24px",
              letterSpacing: "0.15px",
              width: "160px",
              borderRadius: "4px",
              "&:hover": {
                backgroundColor: "#002878",
                color: "#fff",
              },
            }}
            variant="contained"
            onClick={handleBulkUpdate}
          >
            Finalizar tickets
          </Button>
        </Tooltip>
      ) : (
        <></>
      )}
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
  handleBulkUpdate: PropTypes.func.isRequired,
};

export default function EnhancedTable({
  onRowClick,
  selected,
  setSelected,
  handleBulkUpdate,
  country,
}) {
  const adminDataQuery = useAdminData({
    countryId: country.id,
  });
  const dataTable = adminDataQuery.data?.data ?? [];
  const dataCount = adminDataQuery.data?.count ?? 0;

  const paginationModel = useBoundStore(
    (state) => state.soAdminPaginationModel,
  );
  const setPaginationModel = useBoundStore(
    (state) => state.setSoAdminPaginationModel,
  );

  const selectedStatus = useBoundStore((state) => state.soAdminSelectedStatus);

  return (
    <Box sx={{ width: "100%" }}>
      {/* Solo para Procesados*/}
      {selectedStatus?.id === 3 && (
        <EnhancedTableToolbar
          numSelected={selected.length}
          handleBulkUpdate={handleBulkUpdate}
        />
      )}
      <DataGridPro
        rows={dataTable}
        loading={adminDataQuery.isFetching}
        checkboxSelection={selectedStatus?.id === 3}
        keepNonExistentRowsSelected={true}
        rowCount={dataCount}
        paginationMode="server"
        pagination={true}
        onPaginationModelChange={setPaginationModel}
        paginationModel={paginationModel}
        onRowClick={onRowClick}
        onRowSelectionModelChange={(newSelectionModel) => {
          setSelected(newSelectionModel);
        }}
        rowSelectionModel={selected}
        disableColumnReorder
        disableColumnMenu
        disableColumnSorting
        disableColumnResize
        slots={slots}
        disableRowSelectionOnClick
        getRowId={(row) => row.id}
        columns={columns}
        sx={tableStyles}
      />
    </Box>
  );
}

const columns = [
  {
    headerAlign: "center",
    headerClassName: "header",
    align: "center",
    flex: 1,
    minWidth: 100,
    field: "id",
    headerName: "ID",
  },
  {
    headerAlign: "center",
    headerClassName: "header",
    align: "center",
    flex: 1,
    minWidth: 150,
    field: "envios_numero_de_seguimiento",
    headerName: "Número de envío",
  },
  {
    headerAlign: "center",
    headerClassName: "header",
    align: "center",
    flex: 1,
    minWidth: 180,
    field: "ventas_num_de_venta",
    headerName: "Número de Venta",
  },
  {
    headerAlign: "center",
    headerClassName: "header",
    align: "center",
    flex: 1,
    minWidth: 150,
    field: "date_created",
    headerName: "Fecha de Carga",
    valueGetter: (value, row) => {
      let newVal = new Date(row.date_created).toISOString().split("T")[0];
      return newVal;
    },
  },
  {
    headerAlign: "center",
    headerClassName: "header",
    align: "center",
    flex: 1,
    minWidth: 150,
    field: "devoluciones_fecha_entregado",
    headerName: "Fecha Devolucion",
    valueGetter: (value, row) => {
      let newVal = new Date(row.devoluciones_fecha_entregado)
        .toISOString()
        .split("T")[0];
      return newVal;
    },
  },
  {
    headerAlign: "center",
    headerClassName: "header",
    align: "center",
    flex: 1,
    minWidth: 150,
    field: "publicaciones_sku",
    headerName: "SKU",
  },
  {
    headerAlign: "center",
    headerClassName: "header",
    align: "center",
    flex: 1,
    minWidth: 180,
    field: "origen_devolucion_name",
    headerName: "Origen Devolucion",
  },
  {
    headerAlign: "center",
    headerClassName: "header",
    align: "center",
    flex: 1,
    minWidth: 100,
    field: "action",
    headerName: "Accion",
    renderCell: (params) => {
      return (
        <Button
          sx={{
            color: "#002878",
            textTransform: "uppercase",
            "&:hover": {
              backgroundColor: "#00287844",
              color: "#002878",
            },
          }}
          //   onClick={() => onRowClick(params.row)}
        >
          Abrir
        </Button>
      );
    },
  },
];
